"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelemetryClient = exports.EVENT_NOT_SENT_MSG = void 0;

var _Context = require("./Context");

var _Event = require("./Event");

var _Message = require("./Message");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const IGUAZU_EDGE_URL = 'https://iguazu.doordash.com/iguazu-edge/v1';
const EVENT_NOT_SENT_MSG = 'Event not sent because of missing consent';
exports.EVENT_NOT_SENT_MSG = EVENT_NOT_SENT_MSG;

class TelemetryClient {
  constructor(entityId, url = IGUAZU_EDGE_URL) {
    _defineProperty(this, "entityId", void 0);

    _defineProperty(this, "context", void 0);

    _defineProperty(this, "url", void 0);

    _defineProperty(this, "userId", void 0);

    _defineProperty(this, "consent", void 0);

    this.entityId = entityId;
    this.context = new _Context.Context();
    this.url = url;
    this.userId = null;
    this.consent = false;
  }

  setConsent(consent) {
    this.consent = consent;
  }

  identify(userId) {
    this.userId = userId;
  }

  async event(name, properties) {
    if (!this.consent) {
      return new Response(EVENT_NOT_SENT_MSG);
    }

    const events = [new _Event.Event(name, properties)];
    const message = new _Message.Message(this.entityId, this.context, events, this.userId);
    return this.sendMessage(message);
  }

  sendMessage(data) {
    return fetch(this.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'entityId': this.entityId
      },
      body: JSON.stringify(data)
    });
  }

}

exports.TelemetryClient = TelemetryClient;